module.exports = __webpack_public_path__ + "static/img/service_content4-4_icon.41860cb.png";